import { useState, useMemo } from 'react'
import { useShow } from '@/contexts/ShowContext'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/shadcn/tabs'
import { Segmented } from './statistics/components'
import { RANGES, getTimezone } from './statistics/utils'
import ContentTab from './statistics/ContentTab'
import UsersTab from './statistics/UsersTab'

export default function StatisticsPage() {
    const { show } = useShow()
    const [range, setRange] = useState('week')
    const tz = useMemo(() => getTimezone(), [])

    return (
        <div className='flex flex-1 flex-col overflow-hidden'>
            <div className='flex items-center justify-between gap-4 md:px-10 px-2 h-20'>
                <h1 className='text-2xl font-bold border-l-4 border-primary pl-4'>Statistics</h1>
                <Segmented options={RANGES} value={range} onChange={setRange} />
            </div>

            <Tabs defaultValue='content' className='flex flex-1 flex-col overflow-hidden gap-0'>
                <div className='md:px-10 px-2'>
                    <TabsList>
                        <TabsTrigger value='content'>Content</TabsTrigger>
                        <TabsTrigger value='users'>Users</TabsTrigger>
                    </TabsList>
                </div>

                <div className='flex-1 overflow-y-auto md:px-10 px-2 py-4'>
                    <TabsContent value='content' className='mt-0'>
                        {show?._id && <ContentTab showId={show._id} range={range} tz={tz} />}
                    </TabsContent>
                    <TabsContent value='users' className='mt-0'>
                        {show?._id && <UsersTab showId={show._id} range={range} tz={tz} />}
                    </TabsContent>
                </div>
            </Tabs>
        </div>
    )
}
